/* eslint-disable */
import React from 'react';
import { Table } from 'react-bootstrap';

import { PrimaryColor, WhiteColor } from '../../../Assets/colorPalette';
import { countWords } from '../../../Assets/utils';

const convertAnswer = (answer) => {
  if (Array.isArray(answer)) {
    return answer.join(', ');
  }
  return answer;
};

const styles = {
  table: {
    borderColor: '#dde1ea',
    fontSize: '0.92rem'
  },
  section: {
    backgroundColor: PrimaryColor,
    color: WhiteColor,
    fontWeight: 600,
    fontSize: '0.95rem',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    padding: '12px'
  },
  colHead: {
    backgroundColor: '#eef1f6',
    color: PrimaryColor,
    fontWeight: 600,
    fontSize: '0.78rem',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    padding: '10px'
  },
  cell: {
    padding: '9px 12px',
    verticalAlign: 'middle'
  },
  numCell: {
    fontWeight: 600,
    color: '#6b7280',
    width: '64px'
  },
  keyCell: {
    color: '#4b5563'
  },
  empty: {
    color: '#b0b6c1'
  },
  wordCount: {
    marginTop: '8px',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: PrimaryColor
  }
};

const rowBg = (index) => (index % 2 === 0 ? '#ffffff' : '#f7f8fb');

const ObjectiveSection = ({ title, answer = {}, answerKey = {}, numbers }) => (
  <>
    <tr>
      <td colSpan={3} className="text-center" style={styles.section}>
        {title}
      </td>
    </tr>
    <tr>
      <td className="text-center" style={styles.colHead}>
        No
      </td>
      <td className="text-center" style={styles.colHead}>
        Answer
      </td>
      <td className="text-center" style={{ ...styles.colHead, width: '45%' }}>
        Answer Key
      </td>
    </tr>
    {numbers.map((n, index) => {
      const value = convertAnswer(answer[n]);
      return (
        <tr key={n} className="text-center" style={{ backgroundColor: rowBg(index) }}>
          <td style={{ ...styles.cell, ...styles.numCell }}>{n}</td>
          <td style={styles.cell}>
            {value === '' || value === undefined || value === null ? (
              <span style={styles.empty}>—</span>
            ) : (
              value
            )}
          </td>
          <td style={{ ...styles.cell, ...styles.keyCell }}>{convertAnswer(answerKey[n])}</td>
        </tr>
      );
    })}
  </>
);

const AnswerTable = ({
  listeningAnswer = {},
  listeningAnswerKey = {},
  readingAnswer = {},
  readingAnswerKey = {},
  writingAnswer = [],
  count = 40
}) => {
  const numbers = Array.from({ length: count }, (_, i) => i + 1);

  return (
    <Table bordered responsive className="mb-0" style={styles.table}>
      <tbody>
        <ObjectiveSection
          title="Listening"
          answer={listeningAnswer}
          answerKey={listeningAnswerKey}
          numbers={numbers}
        />
        <ObjectiveSection
          title="Reading"
          answer={readingAnswer}
          answerKey={readingAnswerKey}
          numbers={numbers}
        />
        <tr>
          <td colSpan={3} className="text-center" style={styles.section}>
            Writing
          </td>
        </tr>
        <tr>
          <td className="text-center" style={styles.colHead}>
            No
          </td>
          <td colSpan={2} style={styles.colHead}>
            Answer
          </td>
        </tr>
        {writingAnswer.map((text, index) => (
          <tr key={index} style={{ backgroundColor: rowBg(index) }}>
            <td className="text-center" style={{ ...styles.cell, ...styles.numCell }}>
              {index + 1}
            </td>
            <td colSpan={2} style={styles.cell}>
              {text ? (
                <>
                  <p className="text-justify text-pre-line mb-0">{text}</p>
                  <div style={styles.wordCount}>
                    Writing Task {index + 1} word count: {countWords(text)}
                  </div>
                </>
              ) : (
                <span style={styles.empty}>—</span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default AnswerTable;
